export const selectConfirmBoxes = (state: any) => state.confirmBoxes

export const getModals = (state: any) => state.modals
export const toggleModal = (params = {}) => ({
  type: 'MODAL_TOGGLE',
  params,
})

export const selectPostBoxModal = (state: any) =>
  getModals(state)?.postBox ?? {}
export const togglePostBoxModal = (params = {}) =>
  toggleModal({ ...params, key: 'postBox' })

export const selectThreadBoxModal = (state: any) =>
  getModals(state)?.threadBox ?? {}
export const toggleThreadBoxModal = (params: any = {}) =>
  toggleModal({
    ...params,
    key: 'threadBox',
    retainPreviousState: params?.retainPreviousState ?? true,
  })

export const getIsEternalImageMode = (state: any) => (chatRoomId: any) =>
  state?.chatSetting?.[chatRoomId]?.isEternalImageMode ?? true
export const setEternalImageModeTo = ({ chatRoomId, isActive }) => ({
  type: 'CHAT_ETERNAL_IMAGE_MODE',
  payload: {
    key: chatRoomId,
    isActive,
  },
})
